module.exports = __webpack_public_path__ + "static/img/cont32_02.a95355b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_02.jpg
// module id = xEmv
// module chunks = 0